module.exports = __webpack_public_path__ + "static/roboto-v18-latin-500-95204ac95130828753c0ee0ada537c33.svg";